module.exports = __webpack_public_path__ + "img/AP_logo_esteso_altro.4dbb86d0.svg";